import { useEffect, useRef } from "react";

import UserFormIcon from '@/icons/UiUserForm';


export default function LobbyVideo({ videoStream }: { videoStream?: MediaStream }) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(function assignVideoStreamToVideoElement() {
    if (videoStream && videoRef.current) {
      videoRef.current.srcObject = videoStream;
    }
  }, [videoStream]);

  if (!videoStream) {
    return (
      <div className="flex w-full items-center justify-center rounded-2xl bg-black-2 py-16 shadow-lg ring-1 ring-black/5 dark:bg-gray-800 dark:ring-white/10 md:py-28">
        <UserFormIcon className="size-28" viewBox="0 0 115 114" />
      </div>
    );
  }

  return (
    <video
      ref={videoRef}
      muted={true}
      autoPlay
      playsInline
      // The lobby preview is always the front camera looking at the customer,
      // so it has to read like a mirror, same as the self-view in the call.
      // A phone has one screen to spend: the preview answers "do I look all
      // right" from a compact card and leaves the notice and the button in
      // view. A desktop has room for the whole frame.
      className="aspect-video w-full -scale-x-100 rounded-2xl bg-black-2 object-cover shadow-lg ring-1 ring-black/5 dark:bg-gray-800 dark:ring-white/10 md:aspect-auto md:object-contain"
    />
  );
}
